import React, { useEffect } from 'react';

export default function Lightbox({ item, onClose }) {
    useEffect(() => {
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        if (item) window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [item, onClose]);

    if (!item) return null;

    return (
        <div
            className="fixed inset-0 z-[300] flex items-center justify-center p-4 md:p-8 animate-lightbox-in"
            onClick={onClose}
        >
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/80 backdrop-blur-[12px]" />

            {/* Content */}
            <div
                className="relative z-10 w-full max-w-[800px] max-h-[85vh] flex flex-col rounded-3xl overflow-hidden shadow-[0_24px_80px_rgba(0,0,0,0.5)] animate-lightbox-content"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Close button */}
                <button
                    className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center text-white/80 hover:text-white hover:bg-black/60 transition-all duration-200 text-lg"
                    onClick={onClose}
                    aria-label="Close lightbox"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>

                {/* Image area */}
                <div className="w-full aspect-[16/10] relative bg-black">
                    <img
                        src={item.imageLink}
                        alt={item.title}
                        className="w-full h-full object-contain"
                    />
                </div>

                {/* Info bar */}
                <div className="bg-[#1a1a2e] px-6 md:px-8 py-5 md:py-6">
                    <div className="flex items-start justify-between gap-4">
                        <div>
                            <h3 className="text-lg md:text-xl font-bold text-white mb-1">{item.title}</h3>
                            <p className="text-white/60 text-sm flex items-center gap-2">
                                <i className={item.type === 'photo' ? 'fa-solid fa-location-dot' : 'fa-solid fa-palette'}></i>
                                {item.subtitle}
                            </p>
                            {item.extra && (
                                <p className="text-white/40 text-sm flex items-center gap-2 mt-1">
                                    <i className="fa-solid fa-camera"></i>
                                    {item.extra}
                                </p>
                            )}
                        </div>
                        <div className="flex items-center gap-2 shrink-0">
                            {item.locationLink && (
                                <a
                                    href={item.locationLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-[#00bcd4]/20 hover:text-[#00bcd4] transition-all duration-200"
                                    title="View on Maps"
                                >
                                    <i className="fa-solid fa-location-dot text-sm"></i>
                                </a>
                            )}
                            <span className="px-3 py-1 bg-white/10 rounded-full text-xs font-semibold text-white/60 uppercase tracking-wider">
                                {item.type === 'photo' ? 'Photography' : 'Artwork'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
